/** Address fields copied by the registration form. Contact details remain independent. */
export const ADDRESS_FIELDS = [
  "no", "name", "type", "town", "street", "road", "province", "district", "city", "zipcode",
] as const;

type Address = Record<string, unknown>;

export const copyResidentialAddress = (home: Address = {}, present: Address = {}): Address => {
  const next = { ...present };
  ADDRESS_FIELDS.forEach((field) => {
    next[field] = home[field] ?? (field === "type" || field === "province" || field === "district" || field === "city" ? null : "");
  });
  return next;
};

export const sameResidentialAddress = (home: Address = {}, present: Address = {}): boolean => {
  const hasAddress = ADDRESS_FIELDS.some((field) => home[field] !== null && home[field] !== undefined && home[field] !== "");
  return hasAddress && ADDRESS_FIELDS.every((field) => (home[field] ?? "") === (present[field] ?? ""));
};

/** Keep existing home and office numbers distinct even though the main form has one other-phone input. */
export const otherPhoneField = (address: Address = {}): "tel_home" | "tel_office" =>
  !address.tel_home && address.tel_office ? "tel_office" : "tel_home";
